import React from "react";
import { useNavigate } from "react-router-dom";
import { LogOut, LayoutDashboard, Languages, Users } from "lucide-react";
import { Logo } from "./Logo";
import { useAuth } from "../context/AuthContext";

const LangToggle = () => {
  const { lang, setLang } = useAuth();
  return (
    <div
      data-testid="lang-toggle"
      className="flex items-center rounded-sm overflow-hidden border"
      style={{ borderColor: "var(--border)" }}
    >
      {["id", "en"].map((l) => (
        <button
          key={l}
          data-testid={`lang-${l}`}
          onClick={() => setLang(l)}
          className="px-3 py-1.5 text-xs font-semibold uppercase tracking-wider transition-colors"
          style={{
            background: lang === l ? "var(--gold)" : "transparent",
            color: lang === l ? "var(--navy)" : "var(--text-dim)",
          }}
        >
          {l}
        </button>
      ))}
    </div>
  );
};

export const Header = () => {
  const navigate = useNavigate();
  const { user, logout, t } = useAuth();

  return (
    <header
      className="sticky top-0 z-40 w-full backdrop-blur-xl border-b"
      style={{ background: "rgba(14,31,51,0.8)", borderColor: "var(--border)" }}
    >
      <div className="max-w-6xl mx-auto px-5 sm:px-8 h-16 flex items-center justify-between">
        <Logo onClick={() => navigate("/")} />
        <div className="flex items-center gap-3">
          <LangToggle />
          <button
            data-testid="nav-test-btn"
            onClick={() => navigate("/test")}
            className="hidden sm:inline-flex text-sm font-medium px-3 py-2 transition-colors"
            style={{ color: "var(--text-dim)" }}
            onMouseEnter={(e) => (e.currentTarget.style.color = "var(--gold)")}
            onMouseLeave={(e) => (e.currentTarget.style.color = "var(--text-dim)")}
          >
            {t("nav_test")}
          </button>
          {(user?.role === "trainer" || user?.role === "admin") && (
            <button
              data-testid="nav-dashboard-btn"
              onClick={() => navigate("/trainer")}
              className="inline-flex items-center gap-2 text-sm font-medium px-3 py-2"
              style={{ color: "var(--gold)" }}
            >
              <LayoutDashboard size={16} /> <span className="hidden sm:inline">{t("nav_dashboard")}</span>
            </button>
          )}
          {user?.role === "admin" && (
            <button
              data-testid="nav-admin-btn"
              onClick={() => navigate("/admin")}
              className="inline-flex items-center gap-2 text-sm font-medium px-3 py-2"
              style={{ color: "var(--gold)" }}
            >
              <Users size={16} /> <span className="hidden sm:inline">{t("nav_admin")}</span>
            </button>
          )}
          {user ? (
            <div className="flex items-center gap-3">
              <div className="hidden sm:flex flex-col items-end leading-tight">
                <span className="text-sm" style={{ color: "var(--text)" }}>{user.name}</span>
                <span
                  data-testid="role-badge"
                  className="text-[10px] uppercase tracking-[0.18em]"
                  style={{ color: user.role === "participant" ? "var(--text-dim)" : "var(--gold)" }}
                >
                  {t(user.role)}
                </span>
              </div>
              <button
                data-testid="logout-btn"
                onClick={() => {
                  logout();
                  navigate("/");
                }}
                className="btn-outline-gold inline-flex items-center gap-2 px-3 py-2 text-sm"
              >
                <LogOut size={15} /> <span className="hidden sm:inline">{t("nav_logout")}</span>
              </button>
            </div>
          ) : (
            <button
              data-testid="nav-login-btn"
              onClick={() => navigate("/login")}
              className="btn-gold px-4 py-2 text-sm"
            >
              {t("nav_login")}
            </button>
          )}
        </div>
      </div>
    </header>
  );
};
